import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Footer = ({ linksOnly = false }) => {
  const { t } = useTranslation();
  const th = (h) => t(`nav.${h}`, h);

  const links = (
    <>
      <NavLink to="/about">{th('About')}</NavLink>
      <NavLink to="/terms">{th('Terms')}</NavLink>
      <NavLink to="/disclaimer">{th('Disclaimer')}</NavLink>
      <NavLink to="/contact">{th('Contact')}</NavLink>
      <NavLink to="/datapolicystatement">{th('datapolicystatement')}</NavLink>

      <span>
        ©
        {' '}
        {new Date().getFullYear()}
        {' '}
        {th('RightsReserved')}
      </span>
    </>
  );

  return linksOnly ? (
    links
  ) : (
    <footer>
      <div className="container">
        <nav className="footer-nav d-md-flex justify-content-center fontBorder">
          {links}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
